var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophyWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 42,
    viewBox: "0 0 50 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.2727 32.522V37.3333H38.6364V42H11.3636V37.3333H22.7273V32.522C18.3334 31.9532 14.2928 29.7576 11.3636 26.3474C8.43452 22.9372 6.81826 18.5468 6.81818 14V0H43.1818V14C43.1817 18.5468 41.5655 22.9372 38.6364 26.3474C35.7072 29.7576 31.6666 31.9532 27.2727 32.522ZM11.3636 4.66667V14C11.3636 17.713 12.8003 21.274 15.3576 23.8995C17.9149 26.525 21.3834 28 25 28C28.6166 28 32.0851 26.525 34.6424 23.8995C37.1997 21.274 38.6364 17.713 38.6364 14V4.66667H11.3636ZM0 4.66667H4.54545V14H0V4.66667ZM45.4545 4.66667H50V14H45.4545V4.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyWhite);
export default __webpack_public_path__ + "static/media/trophy-white.31dca626e088d22aceeb5571fe333cc1.svg";
export { ForwardRef as ReactComponent };